export enum PermissionAccess {
  R = 'R',
  W = 'W',
  E = 'E',
}

export enum PermissionItem {
  SYS_ROLE_MANAGE = 'SYS_ROLE_MANAGE',
  SYS_IDENTITY_AGENT_MANAGE = 'SYS_IDENTITY_AGENT_MANAGE',
  SYS_IDENTITY_STAFF_MANAGE = 'SYS_IDENTITY_STAFF_MANAGE',
  SYS_CALENDAR = 'SYS_CALENDAR',
  SYS_CALENDAR_REVIEWER = 'SYS_CALENDAR_REVIEWER',
  SYS_CALENDAR_APPROVE = 'SYS_CALENDAR_APPROVE',
  SYS_AUDIT_LOG = 'SYS_AUDIT_LOG',
  SYS_ATTRIBUTE_CONTROL = 'SYS_ATTRIBUTE_CONTROL',
  SYS_REPORT_CENTER = 'SYS_REPORT_CENTER',
  CUSTOMER_EMPLOYER = 'CUSTOMER_EMPLOYER',
  CUSTOMER_EMPLOYER_SQ = 'CUSTOMER_EMPLOYER_SQ',
  CUSTOMER_EMPLOYER_SUBSIDIARY = 'CUSTOMER_EMPLOYER_SUBSIDIARY',
  CUSTOMER_MEMBER = 'CUSTOMER_MEMBER',
  CUSTOMER_MOBILE_SUBSCRIPTION = 'CUSTOMER_MOBILE_SUBSCRIPTION',
  CUSTOMER_SERVICING_AGENT = 'CUSTOMER_SERVICING_AGENT',
  CUSTOMER_EMPLOYER_INTERMEDIARY = 'CUSTOMER_EMPLOYER_INTERMEDIARY',
  COMMISSION_SCHEME_MASTER_RECORD = 'COMMISSION_SCHEME_MASTER_RECORD',
  COMMISSION_SCALE_MANAGEMENT = 'COMMISSION_SCALE_MANAGEMENT',
  COMM_INFO_MAIN_COMM_SUMMARY = 'COMM_INFO_MAIN_COMM_SUMMARY',
  COMM_INFO_RELATED_PARTIES = 'COMM_INFO_RELATED_PARTIES',
  COMM_INFO_SCALE_RECORD = 'COMM_INFO_SCALE_RECORD',
  COMM_INFO_AGENT_COMP = 'COMM_INFO_AGENT_COMP',
  COMM_INFO_AGENT_CHANGE = 'COMM_INFO_AGENT_CHANGE',
  COMM_INFO_INDIVIDUAL_TRF = 'COMM_INFO_INDIVIDUAL_TRF',
  COMMISSION_JOURNAL = 'COMMISSION_JOURNAL',
  COMM_HOLD_ON_COMPENSATION_REPORT = 'COMM_HOLD_ON_COMPENSATION_REPORT',
  COMMISSION_ERROR_LOG = 'COMMISSION_ERROR_LOG',
  COMM_ADJ_BATCH_UPLOAD = 'COMM_ADJ_BATCH_UPLOAD',
  COMM_APE_JOURNAL = 'COMM_APE_JOURNAL',
  COMMISSION_DEFAULT_SCALE = 'COMMISSION_DEFAULT_SCALE',
  COMM_APE_MANUAL_ADJ_NBV_RATIO = 'COMM_APE_MANUAL_ADJ_NBV_RATIO',

  CUSTOMER_EMPLOYEE = 'CUSTOMER_EMPLOYEE',
  CUSTOMER_EMPLOYEE_INTERMEDIARY = 'CUSTOMER_EMPLOYEE_INTERMEDIARY',
  CUSTOMER_EMPLOYEE_AML = 'CUSTOMER_EMPLOYEE_AML',
  CUSTOMER_EMPLOYER_AML = 'CUSTOMER_EMPLOYER_AML',

  SHK_AGENT_ASSIGNMENT_AGENT = 'SHK_AGENT_ASSIGNMENT_AGENT',
  CUSTOMER_EMPLOYER_ADDITIONAL_INFORMATION = 'CUSTOMER_EMPLOYER_ADDITIONAL_INFORMATION',
  CUSTOMER_EMPLOYER_ACTIVITY_CODE = 'CUSTOMER_EMPLOYER_ACTIVITY_CODE',
  CUSTOMER_EMPLOYER_VIP_CODE = 'CUSTOMER_EMPLOYER_VIP_CODE',
  SALES_JOURNEY_SALES_SUPPORT = 'SALES_JOURNEY_SALES_SUPPORT',
  SALES_JOURNEY_AGENT = 'SALES_JOURNEY_AGENT',
  SALES_JOURNEY_SUPER_USER = 'SALES_JOURNEY_SUPER_USER',
  SALES_JOURNEY_SUPER_ADMIN = 'SALES_JOURNEY_SUPER_ADMIN',
  AGENT_SEP_ENROLMENT = 'AGENT_SEP_ENROLMENT',
  SALES_JOURNEY_BANCA_BROKER = 'SALES_JOURNEY_BANCA_BROKER',
  SALES_JOURNEY_PAPER_IFF = 'SALES_JOURNEY_PAPER_IFF',
  SALES_JOURNEY_WSM = 'SALES_JOURNEY_WSM',

  ROBO_ADVISORY = 'ROBO_ADVISORY',

  SHK_AGENT_ASSIGNMENT_MAPPING = 'SHK_AGENT_ASSIGNMENT_MAPPING',
  SHK_AGENT_ASSIGNMENT_REPORT = 'SHK_AGENT_ASSIGNMENT_REPORT',
  SHK_AGENT_ASSIGNMENT_REPORT_AGENT_HEAD = 'SHK_AGENT_ASSIGNMENT_REPORT_AGENT_HEAD',
  SHK_AUTO_ROLLOVER_OPS_STAFF = 'SHK_AUTO_ROLLOVER_OPS_STAFF',
  SHK_AGENT_ASSIGNMENT_REASSIGN = 'SHK_AGENT_ASSIGNMENT_REASSIGN',
  SHK_PAYMENT_ISSUANCE_PAYMENT_ADMIN = 'SHK_PAYMENT_ISSUANCE_PAYMENT_ADMIN',
  SHK_PAYMENT_ISSUANCE_PAYMENT_STAFF = 'SHK_PAYMENT_ISSUANCE_PAYMENT_STAFF',
  SHK_PAYMENT_ISSUANCE_PAYMENT_MANAGER = 'SHK_PAYMENT_ISSUANCE_PAYMENT_MANAGER',
  SHK_AGENT_ASSIGNMENT_REPORT_AGENT_HEAD_ENROLMENT = 'SHK_AGENT_ASSIGNMENT_REPORT_AGENT_HEAD_ENROLMENT',

  ORSO_MACAU_PAYMENT_ISSUANCE_PAYMENT_ADMIN = 'ORSO_MACAU_PAYMENT_ISSUANCE_PAYMENT_ADMIN',
  ORSO_MACAU_PAYMENT_ISSUANCE_PAYMENT_STAFF = 'ORSO_MACAU_PAYMENT_ISSUANCE_PAYMENT_STAFF',
  ORSO_MACAU_PAYMENT_ISSUANCE_PAYMENT_MANAGER = 'ORSO_MACAU_PAYMENT_ISSUANCE_PAYMENT_MANAGER',

  COMM_ADJ_NORMAL = 'COMM_ADJ_NORMAL',
  COMM_ADJ_INDIVIDUAL = 'COMM_ADJ_INDIVIDUAL',
  COMM_ADJ_APPEAL = 'COMM_ADJ_APPEAL',

  CHATBOT_CSO = 'CHATBOT_CSO',
  CHATBOT_ADMIN = 'CHATBOT_ADMIN',
  CHATBOT_SUPERVISOR = 'CHATBOT_SUPERVISOR',
  CHATBOT_AGENT = 'CHATBOT_AGENT',

  PAYMENT_DETAIL_ENQUIRY_EXPORT = 'PAYMENT_DETAIL_ENQUIRY_EXPORT',
  FINANCIAL_JOURNAL_ENQUIRY_EXPORT = 'FINANCIAL_JOURNAL_ENQUIRY_EXPORT',

  AML_ADMIN = 'AML_ADMIN',

  INTEREST_RATE_REQUESTER = 'INTEREST_RATE_REQUESTER',
  INTEREST_RATE_APPROVER = 'INTEREST_RATE_APPROVER',
  CREDIT_BAL_INT_RATE_REQUESTER = 'CREDIT_BAL_INT_RATE_REQUESTER',
  CREDIT_BAL_INT_RATE_APPROVER = 'CREDIT_BAL_INT_RATE_APPROVER',

  EMPF_PAYMENT_ISSUANCE_PAYMENT_ADMIN = 'EMPF_PAYMENT_ISSUANCE_PAYMENT_ADMIN',
  EMPF_PAYMENT_ISSUANCE_PAYMENT_STAFF = 'EMPF_PAYMENT_ISSUANCE_PAYMENT_STAFF',
  EMPF_PAYMENT_ISSUANCE_PAYMENT_MANAGER = 'EMPF_PAYMENT_ISSUANCE_PAYMENT_MANAGER',

  BONUS_UNIT_MAINTENANCE_STAFF = 'BONUS_UNIT_MAINTENANCE_STAFF',
  BONUS_UNIT_MAINTENANCE = 'BONUS_UNIT_MAINTENANCE',
  BONUS_UNIT_MANUAL_ADJUSTMENT = 'BONUS_UNIT_MANUAL_ADJUSTMENT',
}
export enum AttributePermissionItem {
  NEXT_COMM_YEAR_START = 'NEXT_COMM_YEAR_START',
  CONT_ADJ_PEND = 'CONT_ADJ_PEND',
}
